import React from 'react';
import { DiabetesPageTemplate } from './DiabetesPageTemplate';
import { diabetesImages } from './diabetesPageData';

const DiabetesSymptoms = () => {
  return (
    <DiabetesPageTemplate
      eyebrow="Signs To Watch"
      title="Diabetes Symptoms"
      intro="Type 1 diabetes often develops quickly, while Type 2 may remain mild and unnoticed for a long time. Knowing the symptoms early can make diagnosis faster and complications less likely."
      heroSummary="Early detection matters because diabetes symptoms are sometimes subtle until blood sugar rises dangerously high."
      heroImage={diabetesImages.symptomImg}
      heroAlt="Illustration of common diabetes symptoms"
      sections={[
        {
          title: 'Common Symptoms Of Type 1 And Type 2 Diabetes',
          columns: [
            {
              title: 'Symptoms Group One',
              items: [
                "Increased appetite and weight loss because cells can't use glucose and the body feels hungry",
                'Increased thirst and frequent urination because excess sugar pulls water into urine',
                'Tiredness, lack of interest and reduced concentration',
                'Tingling, numbness or pain in hands or feet, especially in Type 2 diabetes',
                'Blurred vision',
              ],
            },
            {
              title: 'Symptoms Group Two',
              items: [
                'Itching and infections around genital areas',
                'Slow wound healing',
                'Vomiting and stomach pain',
                'Muscle weakness and fatigue',
              ],
            },
          ],
          image: diabetesImages.heroAltMain,
          imageAlt: 'Diabetes symptom awareness visual',
          imageCaption: 'High blood sugar can affect energy, hydration, nerves, vision, and wound healing at the same time.',
          note: 'High blood sugar prevents cells from absorbing enough energy, which is why constant hunger may continue even after eating.',
        },
        {
          title: 'Symptoms In Men And Women',
          columns: [
            {
              title: 'Men-Specific',
              items: [
                'Reduced muscle mass and strength',
                'Recurrent thrush around genitals',
                'Itching of or around the penis',
                'Erectile dysfunction, especially in uncontrolled diabetes',
              ],
            },
            {
              title: 'Women-Specific',
              items: [
                'Frequent urinary tract infections',
                'Vaginal yeast infections',
                'Polycystic ovary syndrome may be linked',
                'Severe dryness and itching in intimate areas',
              ],
            },
          ],
          note: 'General symptoms such as thirst, fatigue, and blurred vision can affect all genders equally.',
        },
        {
          title: 'Diabetes In Children: Remember The 4Ts',
          columns: [
            {
              title: 'Toilet',
              text: 'Frequent urination, especially at night.',
            },
            {
              title: 'Thirsty',
              text: "Excessive thirst that doesn't improve easily.",
            },
            {
              title: 'Tired',
              text: 'Unexplained fatigue and reduced energy.',
            },
            {
              title: 'Thinner',
              text: 'Sudden weight loss despite eating.',
            },
          ],
          image: diabetesImages.img1,
          imageAlt: 'Child-focused diabetes awareness',
          imageCaption: 'The 4Ts are especially important warning signs for children with possible Type 1 diabetes.',
          note: "Children's diabetes is often missed, so these signs should be discussed with a pediatrician without delay.",
        },
        {
          title: 'Acute Hyperglycemia And Emergency Symptoms',
          paragraphs: [
            'If early symptoms are ignored, blood sugar may rise to dangerous levels and cause emergency symptoms.',
          ],
          items: [
            'Fruity-smelling breath due to ketoacidosis',
            'Troubled or rapid breathing',
            'Increased heart rate and severe weakness',
            'Severe vomiting and stomach pain',
            'Altered consciousness, confusion, or seizures',
          ],
          note: 'Immediate medical help is required. Early detection and treatment significantly reduce complications.',
        },
      ]}
    />
  );
};

export default DiabetesSymptoms;
